import React from 'react';
// import PropTypes from 'prop-types';
import { PsPage } from '../../../shared/components/ps-page/PsPage';
import { I18nUtils } from '../../../../i18n/I18nUtils';
import MonthlyCard from '../components/MonthlyCard.js';
import { BreadcrumbsManagerInstance } from '../../../shared/breadcrumbs/BreadcrumbsManager';
import { Breadcrumbs } from '../../../shared/breadcrumbs/Breadcrumbs';

export default class MonthlyScreen extends React.Component {

    constructor(props) {
        super(props);

        BreadcrumbsManagerInstance.build([
            Breadcrumbs.MY_OUTSOURCES,
            Breadcrumbs.MY_OUTSOURCES_MONTHLY,
        ]);

        this.state = {
            breadcrumbs: BreadcrumbsManagerInstance.breadcrumbs(),
        };
    }

    render() {
        const { breadcrumbs } = this.state;
        return (
            <PsPage title={I18nUtils.tr('TR_MENSUAL')} breadcrumbs={breadcrumbs}>
                <MonthlyCard/>
            </PsPage>
        );
    }
}

MonthlyScreen.propTypes = {};

MonthlyScreen.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/my-outsources/monthly/screens/MonthlyScreen.js